module.exports = __webpack_public_path__ + "media/images/category_icons/software-87095c28c47defa2407151f62e697cfd.svg";